module.exports = __webpack_public_path__ + "554f87d7afe4683cc59a066a25247958.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/onboarding-critical-thinking.png
// module id = 1706
// module chunks = 0